import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBolt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLightningBolt"><Path d="M13.8213 9.25H19.2656L9.51758 22.0234L10.1787 14.75H4.73438L14.4824 1.97656L13.8213 9.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightningBolt;
